import React, { useState, useEffect } from "react";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
  InputLabel,
  Stack,
  InputAdornment,
  Container,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import bgImage from "../../Resources/Images/bg.png";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { ToastError } from "../../UiComponents/Toaster/Toast";
import { LoginService, RegisterService, GetOtp } from "../../Service/_index";
import swal from "../../Shared/swal";
import "./Login.scss";
import loginImage from "../../Resources/Images/loginimg.png";
import signupImage from "../../Resources/Images/signupimg.png";
// import Logo from "../../Resources/Images/rayal.png";
import Logo from "../../Resources/MainIcons/Logo2.png";
import { motion, AnimatePresence } from "framer-motion";
import AnimatedBtnLoader from "./AnimatedBtnLoader";

const Login = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [otpValue, setOtpValue] = useState();
  const [verify, setVerify] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false); // For button animation
  const [showRoleSelection, setShowRoleSelection] = useState(false);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [loginData, setLoginData] = useState(null);
  const navigate = useNavigate();

  const LoginSchema = Yup.object().shape({
    email: Yup.string().min(6, "Too Short").required("Enter Username"),
    password: Yup.string().required("Password is Required"),
  });

  const SignupSchema = Yup.object().shape({
    name: Yup.string().min(1, "Too Short!").required("Enter email"),
    email: Yup.string().email("Invalid email").required("Enter your emails"),
    mobileNumber: Yup.string().required("Enter your mobile Number"),
    newPassword: Yup.string().required("Password is Required"),
    confirmPassword: Yup.string()
      .oneOf(
        [Yup.ref("newPassword"), null],
        'Must match "password" field value'
      )
      .required("Enter Confirm Password"),
  });

  const loginOnSubmit = (data) => {
    setIsLoading(true);
    setIsButtonClicked(true); // Trigger button animation
    if (!isNaN(data.email)) {
      data.mobile = data.email;
      delete data.email;
    } else {
      data.email = data.email;
      delete data.mobile;
    }
    LoginService({
      email: data.email,
      password: data.password,
      mobile: data.mobile,
    })
      .then((res) => {
        const userType = res?.data?.userType;

        // Check if userType is an array with multiple roles
        if (Array.isArray(userType) && userType.length > 1) {
          // Store login data temporarily and show role selection dialog
          setLoginData(res?.data);
          setAvailableRoles(userType);
          setShowRoleSelection(true);
          setIsLoading(false);
          setIsButtonClicked(false);
        } else {
          // Single role or string userType - proceed directly
          const selectedUserType = Array.isArray(userType) ? userType[0] : userType;

          sessionStorage.setItem("email", res?.data?.email);
          sessionStorage.setItem("token", res?.data?.clientID);
          sessionStorage.setItem("name", res?.data?.name);
          sessionStorage.setItem("UserId", res?.data?.userID);
          sessionStorage.setItem("clientID", res?.data?.clientID);
          sessionStorage.setItem("userType", selectedUserType);
          sessionStorage.setItem("roleId", res?.data?.roleId);

          setTimeout(() => {
            setIsLoading(false);
            setIsButtonClicked(false);
            navigate("/dashboard");
          }, 1000);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setIsButtonClicked(false); // Reset button animation
        console.log(err);
        ToastError(err?.response?.data?.error);
      });
  };

  const RegisterOnSubmit = (data) => {
    setIsLoading(true);
    setIsButtonClicked(true); // Trigger button animation
    RegisterService({
      name: data.name,
      mobileNumber: data.mobileNumber,
      email: data.email,
      password: data.newPassword,
    })
      .then((res) => {
        setIsLoading(false);
        setIsButtonClicked(false); // Reset button animation
        if (res?.response?.status === 500) {
          ToastError(res.response.data.message);
        } else {
          swal({
            title: "Registered Successfully!",
            text: "Welcome to Rayal insurance",
            icon: "success",
            buttons: false,
          });
          window.location.reload();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setIsButtonClicked(false); // Reset button animation
        ToastError(err.message);
      });
  };

  const GetOtpFunction = (values) => {
    setShowOtp(true);
    const data = {
      mobileNumber: values.mobileNumber,
      name: values.name,
    };
    GetOtp(data).then((res) => {
      setOtpValue(res.otp);
    });
  };

  const handleRoleSelection = (selectedRole) => {
    if (loginData) {
      sessionStorage.setItem("email", loginData.email);
      sessionStorage.setItem("token", loginData.clientID);
      sessionStorage.setItem("name", loginData.name);
      sessionStorage.setItem("UserId", loginData.userID);
      sessionStorage.setItem("clientID", loginData.clientID);
      sessionStorage.setItem("userType", selectedRole);
      sessionStorage.setItem("roleId", loginData.roleId);

      setShowRoleSelection(false);
      navigate("/dashboard");
    }
  };
  // const texts = [
  //   ["We Are Your Trusted Motor Insurance Partner", "Securely access your motor insurance calculator and find the best coverage in minutes!"],
  //   ["Smart Insurance Choices Start Here", "Secure your vehicle with the best coverage through our easy-to-use insurance calculator."],
  //   ["Quick, Reliable & Transparent Quotes", "No hidden fees—just accurate, instant premium calculations for your peace of mind."],

  // ];

  // const [currentIndex, setCurrentIndex] = useState(0);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
  //   }, 1000);
  //   return () => clearInterval(interval);
  // }, []);

  return (
    <div
      style={{
        display: "flex",
        position: "relative",
        background: "#F6F7F9",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        width: "100%",
        margin: 0,
        padding: 0,
        overflowX: "hidden",
      }}
    >
      {/* Decorative Blurred Circles - #0070FF only in top-left and bottom-right */}
      {/* Top-left blurred circle - BLUE */}
      <Box
        sx={{
          position: "absolute",
          top: { xs: "-80px", sm: "-100px" },
          left: { xs: "-100px", sm: "-150px" },
          width: { xs: "250px", sm: "350px", md: "450px" },
          height: { xs: "250px", sm: "350px", md: "450px" },
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(0, 112, 255, 0.3) 0%, rgba(0, 112, 255, 0.15) 50%, transparent 70%)",
          filter: "blur(60px)",
          pointerEvents: "none",
        }}
      />
      {/* Bottom-right blurred circle - BLUE */}
      <Box
        sx={{
          position: "absolute",
          bottom: { xs: "-100px", sm: "-150px" },
          right: { xs: "-100px", sm: "-150px" },
          width: { xs: "280px", sm: "400px", md: "500px" },
          height: { xs: "280px", sm: "400px", md: "500px" },
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(0, 112, 255, 0.3) 0%, rgba(0, 112, 255, 0.15) 50%, transparent 70%)",
          filter: "blur(70px)",
          pointerEvents: "none",
        }}
      />
      <Grid container alignItems={"center"} justifyContent={"center"} sx={{ minHeight: "100vh", py: { xs: 2, md: 4 } }}>
        <Grid
          item
          xs={11}
          sm={8}
          md={5}
          lg={4}
          xl={3}
          sx={{
            backgroundColor: "white",
            maxWidth: "594px",
            minHeight: "auto",
            borderRadius: "16px",
            boxShadow: "0px 20px 60px rgba(0, 0, 0, 0.15), 0px 8px 25px rgba(0, 0, 0, 0.1)",
            transform: "translateY(0px)",
            transition: "all 0.3s ease",
          }}
        >
          <Grid container className="Login_container">
            <Grid
              item
              xs={12}
              //md={6}
              //lg={6}
              className="Login_container_leftside"
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1,
                padding: { xs: "20px", sm: "28px", md: "25px" },
              }}
            >
              <Stack
                spacing={0.5}
                alignItems={"center"}
                width="100%"
                maxWidth={500}
              >

                <Stack alignItems="center" justifyContent="center">
                  <Box
                    sx={{
                      width: "400px",
                      height: "80px",
                      overflow: "hidden",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={Logo}
                      alt="Logo"
                      style={{
                        width: "300px",
                        height: "200px",
                        objectFit: "contain",
                        transform: "scale(1.5)",
                      }}
                    />
                  </Box>
                </Stack>

                <Typography
                  className="Login_headtext"
                  sx={{
                    textAlign: "center",
                    width: "auto",
                    // whiteSpace: "nowrap",
                    fontSize: { xs: "20px", sm: "23px", md: "25px" },
                    fontWeight: 600,
                    fontFamily: "Inter",
                  }}
                >
                  {isLogin ? "Welcome Back!" : "Create your account"}
                </Typography>
                <Stack>
                  <Typography
                    className="Login_Sub_headerText"
                    sx={{
                      mb: 2,
                      fontWeight: "normal !important",
                      padding: "0px !important ",
                      width: { xs: "100%", sm: "100%", md: "400px" },
                      fontSize: { xs: "13px", sm: "14px", md: "16px" },
                      fontFamily: "Inter",
                      textAlign: "center",
                    }}
                  >
                    {isLogin
                      ? "Log in to manage your motor insurance easily."
                      : "Sign up now to unlock smarter motor insurance decisions!"}
                  </Typography>
                </Stack>

                <Formik
                  key={isLogin ? "login" : "signup"}
                  enableReinitialize
                  validationSchema={isLogin ? LoginSchema : SignupSchema}
                  initialValues={{
                    name: "",
                    email: "",
                    mobileNumber: "",
                    newPassword: "",
                    confirmPassword: "",
                    password: "",
                  }}
                  onSubmit={(values) => {
                    if (isLogin) {
                      loginOnSubmit(values);
                    } else {
                      RegisterOnSubmit(values);
                    }
                  }}
                >
                  {({ errors, touched, values, resetForm }) => (
                    <Form style={{ width: "100%" }} autoComplete="off">
                      <AnimatePresence mode="wait">
                        {!isLogin && (
                          <motion.div
                            key="signup"
                            initial={{ opacity: 0, x: 100 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -100 }}
                            transition={{ duration: 0.1 }}
                          >
                            <Grid container mb={1.5} spacing={{ xs: 0, sm: 2 }}>
                              <Grid item xs={12} sm={6}>
                                <InputLabel
                                  className="Login_lable"
                                  sx={{
                                    color: "black",
                                    fontFamily: "Inter",
                                    marginBottom: "7px",
                                  }}
                                >
                                  Name<span style={{ color: "red" }}>*</span>
                                </InputLabel>
                                <Field
                                  as={TextField}
                                  name="name"
                                  className="custom-textfield"
                                  placeholder="Name"
                                  fullWidth
                                  variant="outlined"
                                  autoComplete="new-name"
                                  style={{ paddingBottom: "5px" }}
                                  sx={{ pb: 2 }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <InputLabel
                                  className="Login_lable"
                                  style={{
                                    color: "black",
                                    fontFamily: "inter",
                                    marginBottom: "7px",
                                  }}
                                >
                                  Email
                                  <span style={{ color: "red" }}>*</span>
                                </InputLabel>
                                <Field
                                  as={TextField}
                                  name="email"
                                  className="custom-textfield"
                                  fullWidth
                                  variant="outlined"
                                  placeholder="Email"
                                  // InputProps={{
                                  //   style: {
                                  //     border: "1px solid #ccc",
                                  //     borderRadius: "6px",
                                  //     // padding: "10px",
                                  //     backgroundColor: "#FFFFFF",
                                  //     fontFamily: "inter",
                                  //   },
                                  //   inputProps: {
                                  //     style: {
                                  //       fontWeight: "normal",
                                  //       fontFamily: "inter",
                                  //     },
                                  //   },
                                  // }}
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  //   style: { marginBottom: "5px" },
                                  // }}
                                  autoComplete="new-email"
                                />
                              </Grid>
                            </Grid>
                          </motion.div>
                        )}

                        {isLogin && (
                          <motion.div
                            key="login"
                            initial={{ opacity: 0, x: -100 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 100 }}
                            transition={{ duration: 0.1 }}
                          >
                            {/* Email Field */}
                            <InputLabel
                              className="Login_lable"
                              sx={{
                                color: "black",
                                fontFamily: "Inter",
                                marginBottom: "7px",
                                // fontSize: { xs: "14px", sm: "16px", md: "18px", lg: "10px" },
                              }}
                            >
                              User Name
                              <span
                                style={{ color: "red", fontWeight: "bold" }}
                              >
                                *
                              </span>
                            </InputLabel>
                            <Field
                              as={TextField}
                              name="email"
                              fullWidth
                              className="custom-textfield"
                              placeholder="Email"
                              // InputProps={{
                              //   style: {
                              //     border: "1px solid #ccc",
                              //     borderRadius: "6px",
                              //     padding: "10px",
                              //     fontFamily: "inter",
                              //     backgroundColor: "white",
                              //   },
                              //   inputProps: {
                              //     style: {
                              //       fontWeight: "500",
                              //       fontFamily: "inter",
                              //     },
                              //   },
                              // }}
                              // InputLabelProps={{
                              //   style: {
                              //     // marginBottom: "5px",
                              //     fontFamily: "inter",
                              //   },
                              // }}
                              sx={{
                                mt: 1,
                                pb: 2,
                                "& input:-webkit-autofill": {
                                  WebkitBoxShadow:
                                    "0 0 0px 1000px white inset !important",
                                  backgroundColor: "white !important",
                                  height: "8px !important",
                                },
                              }}
                            />
                            <InputLabel
                              className="Login_lable"
                              style={{
                                color: "black",
                                fontFamily: "inter",
                                marginBottom: "7px",
                              }}
                            >
                              Password<span style={{ color: "red" }}>*</span>
                            </InputLabel>
                            <Field
                              as={TextField}
                              className="custom-textfield"
                              name="password"
                              fullWidth
                              placeholder="Password"
                              style={{ paddingBottom: "5px" }}
                              type={showPassword ? "text" : "password"}
                              variant="outlined"
                              // InputProps={{
                              //   style: {
                              //     border: "1px solid #ccc",
                              //     borderRadius: "6px",
                              //     padding: "10px",
                              //     backgroundColor: "#FFFFFF",
                              //     fontFamily: "inter",
                              //   },
                              //   inputProps: {
                              //     style: { fontWeight: "500", fontFamily: "inter" },
                              //   },
                              // }}
                              // InputLabelProps={{
                              //   shrink: true,
                              //   style: { marginBottom: "5px" },
                              // }}
                              sx={{
                                pb: 2,
                                mt: 1,
                              }}
                            />
                          </motion.div>
                        )}

                        {!isLogin && (
                          <motion.div
                            key="mobileNumber"
                            initial={{ opacity: 0, x: 100 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -100 }}
                            transition={{ duration: 0.1 }}
                          >
                            <InputLabel
                              className="Login_lable"
                              style={{
                                color: "black",
                                fontFamily: "inter",
                                marginBottom: "7px",
                              }}
                            >
                              Mobile Number
                              <span style={{ color: "red" }}>*</span>
                            </InputLabel>
                            <Field
                              as={TextField}
                              name="mobileNumber"
                              className="custom-textfield"
                              fullWidth
                              variant="outlined"
                              placeholder="Mobile number"
                              // InputProps={{
                              //   style: {
                              //     border: "1px solid #ccc",
                              //     borderRadius: "6px",
                              //     padding: "10px",
                              //     backgroundColor: "#FFFFFF",
                              //     fontFamily: "inter",
                              //   },
                              //   endAdornment: (
                              //     <InputAdornment position="end">
                              //       <Typography
                              //         variant="contained"
                              //         onClick={() => GetOtpFunction(values)}
                              //         sx={{
                              //           borderRadius: "6px",
                              //           textTransform: "none",
                              //           fontFamily: "inter",
                              //           color: "blue",
                              //           cursor: "pointer",
                              //           fontWeight: "normal !important",
                              //         }}>
                              //         Get OTP
                              //       </Typography>
                              //     </InputAdornment>
                              //   ),
                              //   inputProps: {
                              //     style: { fontWeight: "500" },
                              //   },
                              // }}
                              // InputLabelProps={{
                              //   shrink: true,
                              //   style: { marginBottom: "5px" },
                              // }}
                              autoComplete="new-phone"
                              sx={{ pb: 2 }}
                            />
                          </motion.div>
                        )}

                        {showOtp && (
                          <motion.div
                            key="otp"
                            initial={{ opacity: 0, x: 100 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -100 }}
                            transition={{ duration: 0.1 }}
                          >
                            <InputLabel
                              className="Login_lable"
                              style={{
                                color: "black",
                                fontFamily: "inter",
                                marginBottom: "7px",
                              }}
                            >
                              OTP<span style={{ color: "red" }}>*</span>
                            </InputLabel>
                            <TextField
                              fullWidth
                              style={{
                                marginBottom: "10px",
                              }}
                              variant="outlined"
                              placeholder="Enter OTP"
                              InputProps={{
                                style: {
                                  border: "1px solid #ccc",
                                  borderRadius: "6px",
                                  padding: "10px",
                                  backgroundColor: "#FFFFFF",
                                  fontFamily: "inter",
                                },
                              }}
                              InputLabelProps={{
                                shrink: true,
                                style: { marginBottom: "0px" },
                              }}
                            />
                          </motion.div>
                        )}

                        {!isLogin && (
                          <motion.div
                            key="password"
                            initial={{ opacity: 0, x: 100 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -100 }}
                            transition={{ duration: 0.1 }}
                          >
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <InputLabel
                                  className="Login_lable"
                                  style={{
                                    color: "black",
                                    fontFamily: "inter",
                                    marginBottom: "7px",
                                  }}
                                >
                                  Password
                                  <span style={{ color: "red" }}>*</span>
                                </InputLabel>
                                <Field
                                  as={TextField}
                                  className="custom-textfield"
                                  name="newPassword"
                                  fullWidth
                                  placeholder="Password"
                                  type={showPassword ? "text" : "password"}
                                  variant="outlined"
                                  // InputProps={{
                                  //   style: {
                                  //     border: "1px solid #ccc",
                                  //     borderRadius: "6px",
                                  //     padding: "10px",
                                  //     backgroundColor: "#FFFFFF",
                                  //     fontFamily: "inter",
                                  //   },
                                  //   inputProps: {
                                  //     style: { fontWeight: "500" },
                                  //   },
                                  // }}
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  //   style: { marginBottom: "5px" },
                                  // }}
                                  autoComplete="new-password"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <InputLabel
                                  className="Login_lable"
                                  style={{
                                    color: "black",
                                    fontFamily: "inter",
                                    marginBottom: "7px",
                                  }}
                                >
                                  Confirm Password
                                  <span style={{ color: "red" }}>*</span>
                                </InputLabel>
                                <Field
                                  as={TextField}
                                  className="custom-textfield"
                                  name="confirmPassword"
                                  fullWidth
                                  type={showPassword ? "text" : "password"}
                                  variant="outlined"
                                  placeholder="Re-Enter Password"
                                  // InputProps={{
                                  //   style: {
                                  //     border: "1px solid #ccc",
                                  //     borderRadius: "6px",
                                  //     padding: "10px",
                                  //     backgroundColor: "#FFFFFF",
                                  //     fontFamily: "inter",
                                  //   },
                                  //   inputProps: {
                                  //     style: { fontWeight: "500" },
                                  //   },
                                  // }}
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  //   style: { marginBottom: "5px" },
                                  // }}
                                  autoComplete="new-password"
                                />
                              </Grid>
                            </Grid>
                          </motion.div>
                        )}
                      </AnimatePresence>

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={showPassword}
                            onChange={() => setShowPassword(!showPassword)}
                          />
                        }
                        label="Show Password"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontFamily: "inter",
                            fontWeight: "400 !important",
                            fontSize: "14px",
                          },
                        }}
                      />

                      <AnimatedBtnLoader
                        buttonText={isLogin ? "Login" : "Sign Up"}
                        disabled={isLoading}
                        type="submit"
                        style={{ backgroundColor: "rgb(30, 58, 95)" }}
                      />

                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        sx={{
                          display: "none",
                          mt: 2,
                          cursor: "pointer",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: { xs: 0.5, sm: 0 },
                        }}
                        onClick={() => {
                          setIsLogin(!isLogin);
                          setShowOtp(false);
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontSize: { xs: "14px", sm: "16px" },
                            fontWeight: "normal !important",
                            textAlign: "center",
                          }}
                        >
                          {isLogin
                            ? "Don't have an account?"
                            : "Already have an account?"}
                        </Typography>
                        <Typography
                          sx={{
                            color: "blue",
                            pl: { xs: 0, sm: 1 },
                            fontFamily: "inter",
                            fontSize: { xs: "14px", sm: "16px" },
                            fontWeight: "normal !important",
                          }}
                        >
                          {isLogin ? "Sign Up" : "Login"}
                        </Typography>
                      </Stack>

                      {/* Go to Old Web Link */}
                      <Stack
                        direction="row"
                        sx={{
                          display: "none",
                          mt: 2,
                          cursor: "pointer",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                        onClick={() => window.open("http://new.rayal.in.s3-website.ap-south-1.amazonaws.com/login", "_blank")}
                      >
                        <Typography
                          sx={{
                            color: "#1976d2",
                            fontFamily: "inter",
                            fontSize: { xs: "14px", sm: "16px" },
                            fontWeight: "500 !important",
                            textDecoration: "none",
                            "&:hover": {
                              color: "#115293",
                            },
                          }}
                        >
                          Click here to go to Old Web
                        </Typography>
                      </Stack>
                    </Form>
                  )}
                </Formik>
              </Stack>
            </Grid>

            {/* <Grid
                item
                xs={0}
                md={6}
                lg={6}
                gap={"20px"}
                sx={{
                  display: { xs: "none", md: "flex" },
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  padding: "20px"
                }}
              >

                {isLogin ? <img
                  src={loginImage}
                  alt="Signup"
                  style={{
                    width: "80%",
                    height: "auto",
                  }}
                /> : <img
                  src={signupImage}
                  alt="Signup"
                  style={{
                    marginTop: "20px",
                    width: "80%",
                    height: "auto",
                  }}
                />}
                {isLogin ?
                  <>
                    <Typography sx={{
                      fontSize: "30px", fontWeight: "600", fontFamily: "inter"
                    }}>
                      Your Smart Motor Insurance Calculator!
                    </Typography>
                    <Typography sx={{
                      fontSize: "15px", fontWeight: "400", fontFamily: "inter"
                    }}>
                      Compare, Calculate, and Choose the Best Insurance Plan for Your Vehicle with Ease.
                    </Typography>
                    <Stack flexDirection={"row"} gap={"10px"}>
                      <Stack sx={{ backgroundColor: "#EEF5FE", padding: "6px 10px", borderRadius: "15px" }}>✅ 100% Accurate Premiums</Stack>
                      <Stack sx={{ backgroundColor: "#EEF5FE", padding: "6px 15px", borderRadius: "15px" }}>⚡ Quick Comparisons</Stack>
                    </Stack>

                  </>

                  : (
                    <Container maxWidth="sm">
                      <Box textAlign="center">
                        <Typography variant="h4" component="p" sx={{
                          fontSize: "30px", fontWeight: "600", fontFamily: "inter"
                        }}>
                          {texts[currentIndex][0]}
                        </Typography>
                        <Typography variant="h6" component="p" color="textSecondary" sx={{
                          fontSize: "15px", fontWeight: "400", fontFamily: "inter", color: "#000000"
                        }}>
                          {texts[currentIndex][1]}
                        </Typography>
                        <Box mt={2}>
                          {texts.map((_, index) => (
                            <span key={index} style={{
                              display: "inline-block",
                              width: 10,
                              height: 10,
                              margin: "0 5px",
                              borderRadius: "50%",
                              backgroundColor: index === currentIndex ? "#1976d2" : "#ccc"
                            }}></span>
                          ))}
                        </Box>
                      </Box>
                    </Container>
                  )}

              </Grid>*/}
          </Grid>
        </Grid>
      </Grid>

      {/* Simple Role Selection Dialog */}
      <Dialog
        open={showRoleSelection}
        onClose={() => { }}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "8px",
            padding: "24px",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize: "20px",
              textAlign: "center",
              color: "#000",
              mb: 1,
            }}
          >
            Select Your Role
          </Typography>
          <Typography
            sx={{
              mb: 3,
              fontFamily: "Inter",
              fontSize: "14px",
              textAlign: "center",
              color: "#666",
            }}
          >
            You have multiple roles assigned. Choose how you want to proceed:
          </Typography>
          <Stack spacing={2}>
            {availableRoles.map((role) => (
              <Button
                key={role}
                variant="outlined"
                onClick={() => handleRoleSelection(role)}
                sx={{
                  fontFamily: "Inter",
                  fontSize: "15px",
                  fontWeight: 500,
                  py: 1.5,
                  borderRadius: "6px",
                  borderColor: "#d0d0d0",
                  color: "#333",
                  textTransform: "capitalize",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                    borderColor: "#1976d2",
                  },
                }}
              >
                {role === "operator" ? "Operator" : role === "user" ? "User" : role}
              </Button>
            ))}
          </Stack>
          <Typography
            sx={{
              mt: 2.5,
              fontSize: "12px",
              textAlign: "center",
              color: "#999",
              fontFamily: "Inter",
              fontStyle: "italic",
            }}
          >
            You can change your role by logging out and logging in again
          </Typography>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Login;
